import { SaveButton } from '@/src/components/buttons/SaveButton'
import CancelButton from '@/src/components/shared/buttons/CancelButton'
interface ModalActionButtonsProps {
  onSubmit: () => void
  onCancel?: () => void
  isLoading?: boolean
  isSubmitDisabled?: boolean
  submitText: string
  cancelText?: string
  showCancelButton?: boolean
  cancelDataAction?: string
  saveDataAction?: string
}

export const ModalActionButtons = ({
  onCancel,
  onSubmit,
  isLoading = false,
  isSubmitDisabled = false,
  showCancelButton = true,
  submitText,
  cancelText,
  cancelDataAction,
  saveDataAction,
}: ModalActionButtonsProps) => {
  return (
    <>
      {showCancelButton && <CancelButton onClose={onCancel} text={cancelText} dataAction={cancelDataAction} />}
      <SaveButton
        onClick={onSubmit}
        isDisabled={isSubmitDisabled}
        isLoading={isLoading}
        text={submitText}
        variant='primary'
        data-action={saveDataAction}
      />
    </>
  )
}
